"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _environment = _interopRequireDefault(require("../environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import './globalPolyfill';
// import 'whatwg-fetch';
var _default = exports.default = function _default(url, method, body, config) {
  var options = {
    method: method,
    mode: 'cors',
    cache: 'no-cache',
    headers: config.headers,
    body: method !== 'GET' ? JSON.stringify(body) : null
  };
  return Promise.race([fetch(url, options).then(function (res) {
    return parseStatus(res);
  }).catch(function (err) {
    throw new Error(JSON.stringify({
      message: err.statusText,
      code: err.status,
      statusCode: err.status
    }));
  }), new Promise(function (resolve, reject) {
    return setTimeout(function () {
      return reject({
        status: -1,
        response: {
          error: {
            message: 'request timeout',
            code: -1
          }
        }
      });
    }, _environment.default.FRONTEND_REQUEST_TIMEOUT);
  })]);
};
function parseStatus(res) {
  return new Promise(function (resolve, reject) {
    if (res.ok || res.status === 400) {
      resolve(res.json());
    } else {
      reject(res);
    }
  });
}